// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.additional-accessories-view {
  display: flex;
  flex-direction: column;
}
.additional-accessories-view .additional-accessories-view__icon-group {
  position: relative;
}
.additional-accessories-view .additional-accessories-view__icon-group .icon-group__background {
  color: #ebf9fe;
  position: relative;
}
.additional-accessories-view .additional-accessories-view__icon-group .icon-group__accessories {
  color: var(--main-1);
  font-size: 1.1em;
}
.additional-accessories-view .additional-accessories-view__text {
  color: var(--sub-6);
}
.additional-accessories-view .additional-accessories-view__input-label {
  color: var(--sub-8);
  font-weight: 600;
}
.additional-accessories-view .additional-accessories-view__input-label.radio-label {
  color: var(--sub-5) !important;
  font-weight: 400 !important;
}
.additional-accessories-view .additional-accessories-view__input-container {
  border: 1px solid var(--sub-4);
  outline: none;
}
.additional-accessories-view .additional-accessories-view__input-container .input-container__input {
  border: none;
  width: 100%;
  outline: none;
  color: var(--sub-6);
  font-weight: 600;
}
.additional-accessories-view .additional-accessories-view__buttons-container {
  display: flex;
  justify-content: space-between;
}

.radio-buttons {
  display: flex;
  flex-flow: column;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
